import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router'
import { memo, useState } from 'react'
import { ACL_ACTION_TYPE } from '../utils/constants'
import { inject, observer } from 'mobx-react'

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const ContactPage = ({ aclStore, valueInit }) => {
  const [value, setValue] = useState(valueInit)
  const navigate = useNavigate()

  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (newValue === 0) {
      navigate('/utility/contacts/users')
    } else if (newValue === 1) {
      navigate('/utility/contacts/departments')
    }
  }
  return (
    <div className="pl-2 pr-2">
      <Box className="" sx={{}}>
        <Box sx={{}}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab
              className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
              label="Nhân viên"
              {...a11yProps(0)}
            />
            <Tab
              className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0"
              label="Phòng ban"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      </Box>
    </div>
  )
}

export default memo(inject('aclStore')(observer(ContactPage)))
